
















































import { Vue, Component, Mixins } from 'vue-property-decorator';

import MyList from '@/mixins/list';

import Add from './addCategory.vue';
import Edit from './editCategory.vue';

@Component({
  components: {
    Add,
    Edit,
  },
})
export default class extends Mixins(MyList) {
    dispatchType = 'products/categories'

    dispatchTypeDelete = 'products/deleteCategory'

    deleteConfirmContent = '你确定要删除该类别吗？'

    columns: any[] = [
      { title: '编号', dataIndex: 'id' },
      { title: '类别名', dataIndex: 'category_name' },
      { title: '操作', scopedSlots: { customRender: 'action' } },
    ]

    mounted() {
      this.loadData();
    }
}
